module.exports = __webpack_public_path__ + "static/media/pepe-bg.d8ee5092.png";